module.exports = __webpack_public_path__ + "images/circle_bordered.png";